import { fetchAuthSession } from 'aws-amplify/auth';
import { get, put, post, del } from 'aws-amplify/api';

const API_NAME = process.env.REACT_APP_API_1_NAME ? process.env.REACT_APP_API_1_NAME : 'lcrud';

export const delAPI = async (url: string) => {
    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
        const endpoint = process.env.REACT_APP_API_1_ENDPOINT ? process.env.REACT_APP_API_1_ENDPOINT : '';
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString() ? session.tokens?.idToken?.toString() : '';

        const res = await fetch(endpoint + url, {
            method: 'DELETE',
            headers: {
                Authorization: idToken,
            },
        });

        await res.json();
        return;
    }

    const myInit = {
        headers: {},
    };
    const res = await del({ apiName: API_NAME, path: url, options: myInit });
    await res.response;
};

export const postAPI = async (url: string, options) => {
    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
        const endpoint = process.env.REACT_APP_API_1_ENDPOINT ? process.env.REACT_APP_API_1_ENDPOINT : '';
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString() ? session.tokens?.idToken?.toString() : '';

        const res = await fetch(endpoint + url, {
            method: 'POST',
            headers: {
                Authorization: idToken,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(options),
        });

        const res1 = await res.json();

        return res1;
    }

    const myInit = {
        headers: {},
        body: options,
    };
    const res = await post({ apiName: API_NAME, path: url, options: myInit });
    const { body } = await res.response;
    const response = await body.text();
    const res1 = JSON.parse(response);

    return res1;
};

export const putAPI = async (url: string, options) => {
    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
        const endpoint = process.env.REACT_APP_API_1_ENDPOINT ? process.env.REACT_APP_API_1_ENDPOINT : '';
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString() ? session.tokens?.idToken?.toString() : '';

        const res = await fetch(endpoint + url, {
            method: 'PUT',
            headers: {
                Authorization: idToken,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(options),
        });

        await res.json();
        return;
    }

    const myInit = {
        headers: {},
        body: options,
    };
    const res = await put({ apiName: API_NAME, path: url, options: myInit });
    await res.response;
};

export const getAPI = async (url: string) => {
    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
        const endpoint = process.env.REACT_APP_API_1_ENDPOINT ? process.env.REACT_APP_API_1_ENDPOINT : '';
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString() ? session.tokens?.idToken?.toString() : '';

        const res = await fetch(endpoint + url, {
            method: 'GET',
            headers: {
                Authorization: idToken,
            },
        });

        const res1 = await res.json();

        return res1;
    }

    const myInit1 = {
        headers: {},
        // authMode: 'userPool',
    };
    const res = await get({ apiName: API_NAME, path: url, options: myInit1 });

    const { body } = await res.response;
    const response = await body.text();
    const res1 = JSON.parse(response);

    return res1;
};